import { Component, Input, ViewChild, } from '@angular/core';
import { DataTableDynamicContentsDirective } from './dynamic/dynamic.contents.directive';
import * as i0 from "@angular/core";
import * as i1 from "./dynamic/dynamic.contents.directive";
function DataTableChildComponent_ng_template_0_Template(rf, ctx) { }
/**
 * This Component is used to render your custom child row component.
 */
export class DataTableChildComponent {
    constructor(componentFactoryResolver, changeDetectorRef) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngAfterViewInit() {
        this.loadComponent();
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('openChildren') && !changes.openChildren.isFirstChange()) {
            this.childOpen = changes.openChildren.currentValue.indexOf(this.rowIndex) > -1;
            this.componentRef.instance.childOpen(this.childOpen);
        }
    }
    loadComponent() {
        const viewContainerRef = this.childContentsDirective.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent(this.component);
        this.componentRef.instance.data = this.row;
        // without this, everything went boom
        this.changeDetectorRef.detectChanges();
    }
}
DataTableChildComponent.ɵfac = function DataTableChildComponent_Factory(t) { return new (t || DataTableChildComponent)(i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
DataTableChildComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataTableChildComponent, selectors: [["DataTable-child"]], viewQuery: function DataTableChildComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(DataTableDynamicContentsDirective, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childContentsDirective = _t.first);
    } }, inputs: { component: "component", row: "row", rowIndex: "rowIndex", openChildren: "openChildren" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 0, consts: [["DataTableDynamicContents", ""]], template: function DataTableChildComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DataTableChildComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
    } }, dependencies: [i1.DataTableDynamicContentsDirective], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableChildComponent, [{
        type: Component,
        args: [{ selector: 'DataTable-child', template: ' <ng-template DataTableDynamicContents></ng-template> ', styles: ["/*# sourceMappingURL=table.component.css.map */\n"] }]
    }], function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.ChangeDetectorRef }]; }, { component: [{
            type: Input
        }], row: [{
            type: Input
        }], rowIndex: [{
            type: Input
        }], openChildren: [{
            type: Input
        }], childContentsDirective: [{
            type: ViewChild,
            args: [DataTableDynamicContentsDirective, { static: true }]
        }] }); })();
